import astronautpng from "./astronaut.png"
import { Sprite } from "pixi.js"

export const jump = (ticker: any, rocket: any) => {
    let astrounaut = Sprite.from(astronautpng)
    astrounaut.anchor.set(0.5, 0.5)
    astrounaut.x = 0
    astrounaut.y = 30
    let jumpLevel = 0
    rocket.addChild(astrounaut)
    ticker.add(jumpAstronaut)

    function jumpAstronaut() {
        jumpLevel++
        astrounaut.position.set(astrounaut.x, astrounaut.y + jumpLevel / 20)
        astrounaut.scale.set(1 - jumpLevel / 100)
        astrounaut.rotation = jumpLevel / 20
        if (jumpLevel > 50) {
            ticker.remove(jumpAstronaut)
        }
    }
    setTimeout(() => {
        rocket.removeChild(astrounaut)
        ticker.remove(jumpAstronaut)
    }, 800)
}